import React from "react";
import { empiTheme } from "./styles/empiTheme";

export default function Roadmap() {
  return (
    <section id="roadmap" style={section}>
      <div style={container}>
        <div style={eyebrow}>Roadmap</div>
        <h2 style={h2}>Where EmPi evolves</h2>

        <p style={p}>
          EmPi begins with daily rhythm-based guidance — focused on the
          decisions you make every day.
        </p>

        <p style={p}>
          Over time, it expands into deeper pattern recognition and more
          precise, personalized guidance.
        </p>

        <div style={timeline}>
          <div style={milestone}>
            <div style={dot} />
            <div>
              <div style={title}>MVP</div>
              <div style={meta}>In development</div>
            </div>
          </div>

          <div style={milestone}>
            <div style={dot} />
            <div>
              <div style={title}>Early access</div>
              <div style={meta}>Coming soon</div>
            </div>
          </div>

          <div style={milestone}>
            <div style={dot} />
            <div>
              <div style={title}>Expansion</div>
              <div style={meta}>
                More rhythms, deeper personalization, and smarter guidance over
                time
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

const section = {
  padding: empiTheme.layout.sectionPadding,
  background: empiTheme.colors.background,
};

const container = {
  maxWidth: empiTheme.layout.maxWidth,
  margin: "0 auto",
};

const eyebrow = {
  ...empiTheme.typography.eyebrow,
  color: empiTheme.colors.textSecondary,
  marginBottom: 12,
};

const h2 = {
  fontSize: empiTheme.typography.h2.fontSize,
  lineHeight: empiTheme.typography.h2.lineHeight,
  margin: "0 0 14px",
  color: empiTheme.colors.text,
};

const p = {
  fontSize: empiTheme.typography.body.fontSize,
  lineHeight: 1.65,
  margin: "0 0 14px",
  color: empiTheme.colors.text,
  maxWidth: 640,
};

const timeline = {
  display: "grid",
  gap: 12,
  marginTop: 10,
  maxWidth: 520,
};

const milestone = {
  display: "flex",
  gap: 12,
  alignItems: "flex-start",
  padding: 16,
  border: `1px solid ${empiTheme.colors.border}`,
  borderRadius: empiTheme.radius.card,
  background: empiTheme.colors.surface,
  boxShadow: empiTheme.shadow.card,
};

const dot = {
  width: 10,
  height: 10,
  borderRadius: 999,
  background: empiTheme.colors.text,
  marginTop: 6,
  flex: "0 0 auto",
};

const title = {
  fontWeight: 700,
  marginBottom: 2,
  color: empiTheme.colors.text,
};

const meta = {
  fontSize: 14,
  color: empiTheme.colors.textSecondary,
};
